// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1_osd","rootCenter":"LoadMoreObserver_rootCenter__1KZGs","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2cnFz"};